import { buildFilteredTableReportSheet } from './filtered-table-report'

const orgGroupColumns = [
  {
    key: 'division',
    label: 'สายงาน (Group)',
    subLabels: ['ชื่อย่อ', 'สายงาน (ไทย)', 'สายงาน (Eng)']
  },
  { key: 'division_th' },
  { key: 'division_en' },
  {
    key: 'faction',
    label: 'ฝ่าย (Division)',
    subLabels: ['ชื่อย่อ', 'ฝ่าย (ไทย)', 'ฝ่าย (Eng)']
  },
  { key: 'faction_th' },
  { key: 'faction_en' },
  {
    key: 'department',
    label: 'แผนก (Department)',
    subLabels: ['ชื่อย่อ', 'แผนก (ไทย)', 'แผนก (Eng)']
  },
  { key: 'department_th' },
  { key: 'department_en' }
]

const baseIdentityColumns = [
  { key: 'num', label: 'ลำดับ' },
  { key: 'code', label: 'รหัส' },
  { key: 'person_id', label: 'Person ID' },
  { key: 'finger_id', label: 'Finger ID' },
  { key: 'level_id', label: 'Level' },
  { key: 'sex', label: 'เพศ' },
  { key: 'id_card', label: 'ID Card' },
  { key: 'username', label: 'ชื่อผู้ใช้งาน' },
  { key: 'title_th', label: 'คำนำหน้า (ไทย)' },
  { key: 'name_th', label: 'ชื่อ (ไทย)' },
  { key: 'surname_th', label: 'นามสกุล (ไทย)' },
  { key: 'nickname_th', label: 'ชื่อเล่น (ไทย)' },
  { key: 'title_en', label: 'คำนำหน้า (Eng)' },
  { key: 'name_en', label: 'ชื่อ (Eng)' },
  { key: 'surname_en', label: 'นามสกุล (Eng)' },
  { key: 'nickname_en', label: 'ชื่อเล่น (Eng)' }
]

const contactColumns = [
  { key: 'team_th', label: 'ทีม (ไทย)' },
  { key: 'team_en', label: 'ทีม (Eng)' },
  { key: 'position_th', label: 'ตำแหน่ง (ไทย)' },
  { key: 'position_en', label: 'ตำแหน่ง (Eng)' },
  { key: 'report_to', label: 'หัวหน้างาน' },
  { key: 'phone', label: 'มือถือ' },
  { key: 'office_phone', label: 'มือถือออฟฟิศ' },
  { key: 'email', label: 'อีเมล' }
]

const employmentDateColumns = [
  { key: 'start_date_th', label: 'วันเริ่มงาน (ไทย)' },
  { key: 'start_date_en', label: 'วันเริ่มงาน (Eng)' },
  { key: 'contract_start_th', label: 'วันเริ่มสัญญา (ไทย)' },
  { key: 'contract_start_en', label: 'วันเริ่มสัญญา (Eng)' },
  { key: 'date_applied_job', label: 'อายุงาน (ปี)' },
  { key: 'employed_date_th', label: 'วันที่บรรจุ (ไทย)' },
  { key: 'employed_date_en', label: 'วันที่บรรจุ (Eng)' },
  { key: 'contract_end_th', label: 'วันที่สิ้นสุดสัญญา (ไทย)' },
  { key: 'contract_end_en', label: 'วันที่สิ้นสุดสัญญา (Eng)' },
  { key: 'end_date_th', label: 'วันพ้นสภาพ (ไทย)' },
  { key: 'end_date_en', label: 'วันพ้นสภาพ (Eng)' },
  { key: 'resign', label: 'สาเหตุการลาออก' },
  { key: 'type', label: 'ประเภทพนักงาน' },
  { key: 'probation', label: 'สถานะทดลองงาน' }
]

const adminColumns = [
  { key: 'num', label: 'ลำดับ' },
  { key: 'img', label: 'รูปภาพ' },
  ...baseIdentityColumns.slice(1),
  ...orgGroupColumns,
  ...contactColumns,
  { key: 'nationality', label: 'สัญชาติ' },
  { key: 'weight', label: 'น้ำหนัก' },
  { key: 'height', label: 'ส่วนสูง' },
  { key: 'birthday_th', label: 'วันเกิด (ไทย)' },
  { key: 'birthday_en', label: 'วันเกิด (Eng)' },
  { key: 'age', label: 'อายุ' },
  { key: 'payment', label: 'ประเภทการจ่ายเงิน' },
  { key: 'bank', label: 'ธนาคาร' },
  { key: 'account_no', label: 'เลขบัญชี' },
  ...employmentDateColumns,
  { key: 'license_plate', label: 'ทะเบียนรถ' },
  {
    key: 'address_current',
    label: 'ที่อยู่ปัจจุบัน',
    subLabels: ['ที่อยู่', 'ตำบล', 'อำเภอ', 'จังหวัด', 'รหัสไปรษณีย์']
  },
  { key: 'sub_district_current' },
  { key: 'district_current' },
  { key: 'province_current' },
  { key: 'post_code_current' },
  {
    key: 'address_home',
    label: 'ที่อยู่ตามทะเบียนบ้าน',
    subLabels: ['ที่อยู่', 'ตำบล', 'อำเภอ', 'จังหวัด', 'รหัสไปรษณีย์']
  },
  { key: 'sub_district_home' },
  { key: 'district_home' },
  { key: 'province_home' },
  { key: 'post_code_home' },
  { key: 'shift', label: 'ตารางกะ' },
  { key: 'travelling', label: 'การเดินทาง' },
  { key: 'project_name', label: 'Project' },
  { key: 'location_code', label: 'Location' },
  { key: 'org_level_code', label: 'Org Level Code' }
]

const employeeColumns = [
  ...baseIdentityColumns,
  ...orgGroupColumns,
  ...contactColumns,
  { key: 'birthday_th', label: 'วันเกิด (ไทย)' },
  { key: 'birthday_en', label: 'วันเกิด (Eng)' },
  { key: 'start_date_th', label: 'วันเริ่มงาน (ไทย)' },
  { key: 'start_date_en', label: 'วันเริ่มงาน (Eng)' },
  { key: 'contract_start_th', label: 'วันที่เริ่มสัญญา (ไทย)' },
  { key: 'contract_start_en', label: 'วันที่เริ่มสัญญา (Eng)' },
  { key: 'date_applied_job', label: 'อายุงาน (ปี)' },
  { key: 'employed_date_th', label: 'วันที่บรรจุ (ไทย)' },
  { key: 'employed_date_en', label: 'วันที่บรรจุ (Eng)' },
  { key: 'contract_end_th', label: 'วันที่สิ้นสุดสัญญา (ไทย)' },
  { key: 'contract_end_en', label: 'วันที่สิ้นสุดสัญญา (Eng)' },
  { key: 'end_date_th', label: 'วันพ้นสภาพ (ไทย)' },
  { key: 'end_date_en', label: 'วันพ้นสภาพ (Eng)' },
  { key: 'resign', label: 'สาเหตุการลาออก' },
  { key: 'type', label: 'ประเภทพนักงาน' },
  { key: 'probation', label: 'สถานะทดลองงาน' },
  { key: 'shift', label: 'ตารางกะ' },
  { key: 'travelling', label: 'การเดินทาง' },
  { key: 'percent', label: 'ค่าเฉลี่ย' },
  { key: 'project_name', label: 'Project' },
  { key: 'location_code', label: 'Location' }
]

const incomeColumns = [
  ...baseIdentityColumns,
  ...orgGroupColumns,
  { key: 'team_th', label: 'ทีม (ไทย)' },
  { key: 'team_en', label: 'ทีม (Eng)' },
  { key: 'position_th', label: 'ตำแหน่ง (ไทย)' },
  { key: 'position_en', label: 'ตำแหน่ง (Eng)' },
  { key: 'start_date_th', label: 'วันเริ่มงาน (ไทย)' },
  { key: 'start_date_en', label: 'วันเริ่มงาน (Eng)' },
  { key: 'type', label: 'ประเภทพนักงาน' },
  { key: 'probation', label: 'สถานะทดลองงาน' },
  { key: 'travelling', label: 'การเดินทาง' },
  { key: 'in_tel', label: 'ค่าโทรศัพท์' },
  { key: 'in_ot', label: 'OT เหมาจ่าย' },
  { key: 'in_lgn', label: 'ค่าภาษา' },
  { key: 'in_exp', label: 'ค่าประสบการณ์' },
  { key: 'in_shift', label: 'ค่ากะเหมาจ่าย' }
]

export function buildPimAdminEmployeeReportSheet({ filterEx = [], data = [] }) {
  return buildFilteredTableReportSheet({
    filterEx,
    data,
    columns: adminColumns,
    textColumnKeys: ['phone', 'office_phone']
  })
}

export function buildPimEmployeeReportSheet({ filterEx = [], data = [] }) {
  return buildFilteredTableReportSheet({
    filterEx,
    data,
    columns: employeeColumns,
    textColumnKeys: ['phone', 'office_phone']
  })
}

export function buildPimIncomeEmployeeReportSheet({
  filterEx = [],
  data = []
}) {
  return buildFilteredTableReportSheet({
    filterEx,
    data,
    columns: incomeColumns,
    textColumnKeys: ['in_tel']
  })
}

export const pimReportColumnCounts = {
  admin: adminColumns.length,
  employee: employeeColumns.length,
  income: incomeColumns.length
}
